var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart" }, [
    _c(
      "ul",
      _vm._l(_vm.cartItems, function(item, ii) {
        return _c(
          "li",
          [
            item.type == "discount"
              ? [
                  _vm._v("\n        Discount "),
                  _c("span", { staticClass: "price" }, [
                    _vm._v("$ " + _vm._s((item.price * 1 || 0).toFixed(2)))
                  ])
                ]
              : [
                  item.type == "membership"
                    ? _c("span", { staticClass: "title" }, [
                        _vm._v("Membership")
                      ])
                    : _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            item.video ? item.video.title : item.group.title
                          )
                        )
                      ]),
                  _vm._v(" "),
                  item.type == "membership"
                    ? _c("span", { staticClass: "price" }, [_vm._v("$ 129.00")])
                    : _c("span", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(_vm.formatPrice(item.price[0], item.price[1]))
                        )
                      ]),
                  _vm._v(" "),
                  item.duration
                    ? _c("span", { staticClass: "duration" }, [
                        _vm._v(_vm._s(item.duration) + " days")
                      ])
                    : _vm._e()
                ],
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "remove",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.popItem(ii)
                  }
                }
              },
              [_vm._v("×")]
            )
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.cartItems && _vm.cartItems.length
      ? _c(
          "div",
          { staticClass: "total" },
          [
            _c("span", { staticClass: "total-price" }, [
              _vm._v("$ " + _vm._s(_vm.totalPrice))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("IN TOTAL")]),
            _vm._v(" "),
            _c("label", { staticClass: "tc" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.agreeTc,
                    expression: "agreeTc"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.agreeTc)
                    ? _vm._i(_vm.agreeTc, null) > -1
                    : _vm.agreeTc
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.agreeTc,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.agreeTc = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.agreeTc = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.agreeTc = $$c
                    }
                  }
                }
              }),
              _vm._v("I agree to the "),
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.showTc($event)
                    }
                  }
                },
                [_vm._v("Terms and Conditions")]
              )
            ]),
            _vm._v(" "),
            _vm.loggedIn
              ? _c(
                  "div",
                  { staticClass: "discount-code" },
                  [
                    !_vm.discountApplied
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.discount,
                              expression: "discount"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Apply discount code here"
                          },
                          domProps: { value: _vm.discount },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.discount = $event.target.value
                            }
                          }
                        })
                      : _c("span", [
                          _vm._v("Code applied: "),
                          _c("em", [
                            _vm._v(_vm._s(_vm.discountApplied.discountkey))
                          ])
                        ]),
                    _vm._v(" "),
                    _vm.discount
                      ? _c(
                          "a",
                          {
                            staticClass: "discount-button",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.applyDiscount($event)
                              }
                            }
                          },
                          [_vm._v("Apply")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    false && _vm.hasPayPal
                      ? _c(
                          "router-link",
                          {
                            staticClass: "button",
                            attrs: { to: { name: "user.profilepp" } },
                            nativeOn: {
                              click: function($event) {
                                _vm.$parent.cartOpen = false
                              }
                            }
                          },
                          [_vm._v("PayPal")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.agreeTc
              ? _c(
                  "a",
                  {
                    staticClass: "button disabled",
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [_vm._v("PROCEED TO PAYMENT")]
                )
              : _c(
                  "router-link",
                  {
                    staticClass: "button",
                    attrs: { to: { name: "user.profile" } },
                    nativeOn: {
                      click: function($event) {
                        _vm.$parent.cartOpen = false
                      }
                    }
                  },
                  [_vm._v("PROCEED TO PAYMENT")]
                )
          ],
          1
        )
      : _c("div", { staticClass: "empty" }, [
          _c("span", [_vm._v("(cart empty)")])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }